import { z } from "zod";
import { BaseRecord, baseRecordSchema } from "../../../baseRecord";
import { UnableToNormalizeData } from "../../../errors/UnableToNormalizeData/UnableToNormalizeData";
import { paymentMethodsEnum } from "./Payment.method";
import { paymentStatusEnum } from "./Payment.status";

/**
 * schema and types versions
 * from first to last
 */

// v0

const paymentDataV0Schema = z.object({
  status: paymentStatusEnum,
  invoiceAmounts: z.record(
    z.object({
      invoiceId: z.string(),
      paymentAmount: z.number().int().nonnegative(),
      total: z.number().int().nonnegative(),
      paid: z.number().int().nonnegative(), // amount previously paid
      refunded: z.number().int().nonnegative(),
      balanceDue: z.number().int(),
      date: z.number().int(),
    })
  ),
  clientId: z.string(),
  clientName: z.string(),
  patientId: z.string().optional(),
  patientName: z.string().optional(),
  paymentMethod: paymentMethodsEnum,
  totalPaymentAmount: z.number().int(),
  creditAmount: z.number().int(),
  payToCreditBalance: z.boolean(),
  note: z.string().optional(),
});

type PaymentDataV0 = z.infer<typeof paymentDataV0Schema>;

const paymentV0Schema = baseRecordSchema.merge(paymentDataV0Schema);

type PaymentV0 = z.infer<typeof paymentV0Schema>;

const normalizePaymentV0 = (data: any): Payment => {
  try {
    const paymentV0: PaymentV0 = paymentV0Schema.parse(data);

    const { ...rest } = paymentV0;

    // here it's same object cause current v is 0
    const payment: Payment = {
      ...rest,
    };
    return payment;
  } catch (error: any) {
    throw new UnableToNormalizeData({ error: error, data: data });
  }
};

/**
 * current types
 * extend latest types
 */

// latest version is 0 so that's what we using

export const PAYMENT_VERSION = "0";

export type PaymentData = PaymentDataV0;

export type Payment = BaseRecord & PaymentData;

export const paymentDataSchema = paymentDataV0Schema;

export const paymentSchema = paymentV0Schema;

export const normalizePayment = (data: any): Payment => {
  if (!data || !data.version) throw new UnableToNormalizeData(data);
  switch (data.version) {
    case "0":
      return normalizePaymentV0(data);
    default:
      throw new UnableToNormalizeData(data);
  }
};
